import React from 'react'
import styled from 'styled-components'

import { TM_BORDER_RADIUS, SIZES, TAG_COLORS } from '~/common/globalStyles'
import Select, {
  Option,
  SelectProps,
} from '~/views/components/ui/inputs/v2/Select'

interface DropdownColorItemProps {
  color: keyof typeof TAG_COLORS
}

const DropdownColorItem = styled.div<DropdownColorItemProps>`
  width: 100%;
  height: 100%;
  border-radius: ${TM_BORDER_RADIUS}px;
  padding: 2px;
  text-align: center;
  font-size: 10px;
  background-color: ${({ color }) => TAG_COLORS[color || 'green']};
`

const CustomOption = styled(Option)`
  padding: ${SIZES.xxxs} ${SIZES.xxs};
  border-top: none;
`
interface Props {
  updateValue(value: string): void
  color: string
  floating?: boolean
}

const ColorDropdown = ({ updateValue, color, floating }: Props) => {
  return (
    <Select
      value={color}
      name="color"
      onChange={updateValue}
      renderValue={({ value }: SelectProps) => {
        return (
          <div
            style={{
              width: '50%',
              margin: 4,
              borderRadius: 3,
            }}
          >
            <DropdownColorItem color={value as keyof typeof TAG_COLORS} />
          </div>
        )
      }}
      fullWidth
      required
      noPadding
      floating={floating}
      menuWrapper
    >
      {Object.keys(TAG_COLORS).map((tagColor, index) => (
        <CustomOption key={index} value={tagColor}>
          <DropdownColorItem color={tagColor as keyof typeof TAG_COLORS} />
        </CustomOption>
      ))}
    </Select>
  )
}

export default ColorDropdown
